module.exports = __webpack_public_path__ + "static/media/IFC4 Certification.b7bf035f.png";